<mbs-table-grid
  [data]="visibleLicenseTypes()"
  [disableViewSwitch]="true"
  [formGroup]="licensesCountForm"
  [headers]="headers"
  [loading]="loading()"
  [myTrackBy]="trackBy">
  <ng-template
    let-license
    mbsTableCell>
    <span class="position-relative">
      {{ license.licenseType | licenseType }}
      @if (getTooltip(license.licenseType); as tooltip) {
        <i
          class="ico ico-info-circle text-sm text-info"
          container="body"
          triggers="mouseenter:mouseleave"
          [closeDelay]="tooltip.interactive ? 1000 : 0"
          [ngbPopover]="tooltipTmp">
          <ng-template #tooltipTmp><div [innerHTML]="tooltip.text"></div></ng-template>
        </i>
      }
    </span>
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    @if (license.isOnlyOne) {
      <mbs-checkbox [formControlName]="license.licenseType"></mbs-checkbox>
    } @else {
      <mbs-number
        [formControlName]="license.licenseType"
        [min]="0"
        [value]="0"></mbs-number>
    }
  </ng-template>

  @if (isBuyLicensesAllow()) {
    <ng-template
      let-license
      mbsTableCell>
      @if (getPrices(license).specialPrice) {
        <div class="text-decoration-line-through text-end">
          {{ getPrices(license)?.basePrice | pricePrepayment: getPeriod(license.licenseType) | async }}
        </div>
        <div>
          <span class="text-success"
            >{{ getPrices(license)?.unitListPrice | pricePrepayment: getPeriod(license.licenseType) | async }}
          </span>
          <span
            #tooltip="ngbTooltip"
            class="sale discount-percent-badge rounded-1 text-xs fw-bold d-inline-flex align-items-center justify-content-center cursor-pointer"
            container="body"
            placement="right-top"
            tooltipClass="tooltip-xl -no-arrow"
            triggers="manual"
            [autoClose]="false"
            [ngbTooltip]="tooltipTmp"
            (click)="tooltip.open()"
            >%
            <ng-template #tooltipTmp>
              <div class="tooltip-content hint text-sm">
                <div class="d-flex">
                  <div class="col-11 tooltip_text-lg text-start">
                    <div>The discounted license price applied only if MSP360 (Amazon S3) storage is exclusively used</div>
                    <div class="mt-3">
                      <a
                        target="_blank"
                        [helpLink]="'/administration/licenses/aws-ub-licenses'">
                        {{ 'shared:buttons.learnMore' | i18next }}
                        <i class="ico ico-external-link-square"></i>
                      </a>
                    </div>
                  </div>
                  <div class="col-1 text-end">
                    <button
                      class="ctrl ctrl-dark"
                      size="lg"
                      type="button"
                      (click)="tooltip.close()">
                      <span class="ico ico-Close"></span>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </span>
        </div>
      } @else {
        <div>{{ getPrices(license)?.unitListPrice | pricePrepayment: getPeriod(license.licenseType) | async }}</div>
      }
    </ng-template>

    @if (isDiscountedPriceShown()) {
      <ng-template
        let-license
        mbsTableCell>
        @let discount = getPrices(license)?.discountPercent;

        {{ getPrices(license)?.unitDiscountedPrice | pricePrepayment: getPeriod(license.licenseType) | async }}
        @if (discount) {
          <span class="text-success">(-{{ discount }}%) </span>
        }
        @let ranges = getRanges(license);

        @if (!isSalesRangeNA(ranges)) {
          <span
            #tooltip="ngbTooltip"
            class="sale discount-percent-badge rounded-1 text-xs fw-bold d-inline-flex align-items-center justify-content-center cursor-pointer"
            container="body"
            placement="right-top"
            tooltipClass="tooltip-xl -no-arrow"
            triggers="manual"
            [autoClose]="false"
            [ngbTooltip]="tooltipTmp"
            (click)="tooltip.open()"
            >%
            <ng-template #tooltipTmp>
              <div class="tooltip-content text-sm">
                <div class="d-flex">
                  <div class="col-11 tooltip_text-lg text-start">
                    <div class="mb-3 fw-bold text-sm">Discount ranges</div>
                  </div>
                  <div class="col-1 text-end">
                    <button
                      class="ctrl ctrl-dark"
                      size="lg"
                      type="button"
                      (click)="tooltip.close()">
                      <span class="ico ico-Close"></span>
                    </button>
                  </div>
                </div>

                <div>
                  @for (range of ranges; track range.percent) {
                    <div
                      class="d-flex justify-content-between px-2 py-1 text-xs"
                      [ngClass]="{ 'bg-success-20': range.percent === discount }">
                      <span>
                        @if (range.to) {
                          {{ range.from }} to {{ range.to }}
                        } @else {
                          {{ range.from }} and above licenses
                        }
                      </span>
                      <span>{{ range.percent }}%</span>
                    </div>
                  }
                </div>
              </div>
            </ng-template>
          </span>
        }
      </ng-template>
    }

    <ng-template
      let-license
      mbsTableCell>
      @let isSpecialPrice = getPrices(license).specialPrice;
      @let days = isMonthlyPayment() ? license.monthlyDays : license.annualDays;
      <span [ngClass]="{ 'text-success': isSpecialPrice }">{{ getPrices(license)?.unitProratedPrice | pricePrepayment | async }}</span>
      @if (days) {
        ({{ 'shared:day' | i18next: { count: days } }})
      }
    </ng-template>

    <ng-template
      let-license
      mbsTableCell>
      <span class="fw-bold">{{ getPrices(license)?.totalProratedPrice | pricePrepayment | async }}</span>
    </ng-template>
  }
</mbs-table-grid>
